"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _closeRound = _interopRequireDefault(require("react-icons/lib/io/close-round"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

require('../../../sass/components/shared/elements/infoWindow.css');

var classNames = require('classnames');

var infoIcon = require('../../../images/ic-info-white-24-px.svg');

var InfoWindow = /*#__PURE__*/function (_React$Component) {
  _inherits(InfoWindow, _React$Component);

  var _super = _createSuper(InfoWindow);

  function InfoWindow(props) {
    var _this;

    _classCallCheck(this, InfoWindow);

    _this = _super.call(this, props);
    _this.state = {
      collapsed: true
    };
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.controlInfoWindow = _this.controlInfoWindow.bind(_assertThisInitialized(_this));
    _this.infoWindowToggle = _this.infoWindowToggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InfoWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      _reactRouter.browserHistory.listen(function () {
        _this2.controlInfoWindow();
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.timer = window.setTimeout(this.controlInfoWindow, 100);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      clearTimeout(this.timer);
    }
  }, {
    key: "controlInfoWindow",
    value: function controlInfoWindow(_open) {
      var onClick = this.props.onClick;
      var collapsed = this.state.collapsed;
      var open = _open === 'open';

      if (!collapsed && !open) {
        this.setState({
          collapsed: true
        });

        if (onClick) {
          onClick();
        }
      } else if (open && collapsed) {
        this.setState({
          collapsed: false
        });

        if (onClick) {
          onClick();
        }
      }
    }
  }, {
    key: "infoWindowToggle",
    value: function infoWindowToggle() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          isDemo = _this$props.isDemo,
          openSignUpModal = _this$props.openSignUpModal;

      if (isDemo) {
        openSignUpModal(null, '', 'download');
        return;
      }

      this.setState({
        collapsed: !this.state.collapsed
      });

      if (this.state.collapsed) {
        this.infoWindow.focus(); // remove the timeout
      }

      if (onClick) {
        onClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          outsideText = _this$props2.outsideText,
          outsideTextClass = _this$props2.outsideTextClass,
          windowClass = _this$props2.windowClass,
          noClose = _this$props2.noClose,
          hoverEvents = _this$props2.hoverEvents;
      var windowClasses = classNames({
        'info-window-pane': true,
        open: !this.state.collapsed
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: "-1",
        ref: function ref(el) {
          return _this3.infoWindow = el;
        },
        className: "info-window ".concat(windowClass),
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onClick: this.infoWindowToggle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "info-window-outside",
        onMouseEnter: function onMouseEnter() {
          return hoverEvents && _this3.controlInfoWindow('open');
        },
        onMouseLeave: hoverEvents && this.controlInfoWindow
      }, outsideText ? /*#__PURE__*/_react.default.createElement("p", {
        className: outsideTextClass
      }, outsideText) : /*#__PURE__*/_react.default.createElement("img", {
        className: "info-window-icon ".concat(outsideTextClass),
        src: infoIcon,
        alt: ""
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: windowClasses
      }, !noClose && /*#__PURE__*/_react.default.createElement(_closeRound.default, {
        className: "close-icon",
        onClick: this.controlInfoWindow
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "pane-content"
      }, this.props.children)));
    }
  }]);

  return InfoWindow;
}(_react.default.Component);

exports.default = InfoWindow;